export default "__VITE_ASSET__9FUHdunC__"